export const Role = {
    propertyOwner: 'Property Owner',
    tenant: 'Tenant'
}